export default {"src":"/_next/static/media/3-h.4167462a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};